import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LoadingProvider } from "./shared/hooks/useLoading";
import { ThemesProvider } from "./shared/hooks/useTheme";
import { PopupProvider } from "./shared/hooks/usePopup";
import { AuthProvider } from "./shared/hooks/useAuth";
import { Routers } from "./app/routing/Routers";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadingProvider>
        <ThemesProvider>
          {/* <TranslationProvider> */}
          <PopupProvider>
            <AuthProvider>
              <Routers />
            </AuthProvider>
          </PopupProvider>
          {/* </TranslationProvider> */}
        </ThemesProvider>
      </LoadingProvider>
    </QueryClientProvider>
  );
}

export default App;
